<template>
  <!-- 打卡账号管理 -->
  <div class="warp">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('添加账号')">添加</el-button>
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteGroup">批量删除</el-button>
    </div>
    <!-- 筛选 -->
    <el-form ref="screenForm" :inline="true" :model="screenForm" class="demo-form-inline">
      <el-form-item label="账号：" prop="username">
        <el-input v-model="screenForm.username" />
      </el-form-item>
      <el-form-item label="真实姓名：" prop="name">
        <el-input v-model="screenForm.name" />
      </el-form-item>
      <el-form-item label="联系方式：" prop="contact">
        <el-input v-model="screenForm.contact" />
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData"> 筛选 </el-button>
    </el-form>
    <!-- 列表 -->
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="index" label="#" width="50" /> -->
        <el-table-column type="selection" width="50" />
        <el-table-column prop="username" label="账号" />
        <el-table-column label="头像" width="100">
          <template slot-scope="scope">
            <el-image :src="scope.row.avator" style="width: 70px; height: 70px; border-radius: 8px" @click="previewImage(scope.row.avator)" />
          </template>
        </el-table-column>

        <el-table-column prop="name" label="真实姓名" />
        <el-table-column prop="contact" label="联系方式" />
        <el-table-column label="所在公司">
          <template slot-scope="scope">
            <div v-if="scope.row.company">
              <div>{{ scope.row.company.companyName }}</div>
              <!-- <div v-if="scope.row.company.auth === 0" style="color: #e6a23c">（审核中）</div>
              <div v-else-if="scope.row.company.auth === 1" style="color: #67c23a">（认证通过）</div>
              <div v-else style="color: #f56c6c">（认证拒绝）</div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="zhiwei" label="职位" />
        <!-- <el-table-column prop="email" label="接收简历邮箱" /> -->
        <!-- <el-table-column prop="auth" label="认证状态">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.auth" class="column_radio" @change="verifyAccount($event, scope.row.id)">
              <el-radio :label="0" style="color: #e6a23c">审核中</el-radio>
              <el-radio :label="1" style="color: #67c23a">认证通过</el-radio>
              <el-radio :label="2" style="color: #f56c6c">认证拒绝</el-radio>
            </el-radio-group>
          </template>
        </el-table-column> -->
        <el-table-column label="账号状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0" style="color: #67c23a">正常</div>
            <div v-else-if="scope.row.status === 1" style="color: #e6a23c">已禁用</div>
            <!-- <div v-else style="color: #f56c6c">已禁用</div> -->
          </template>
        </el-table-column>
        <!-- <el-table-column prop="createDate" label="创建时间" /> -->
        <el-table-column prop="address" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="openDialog('编辑账号', scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" style="margin: 6px 0 0" @click="handleDeleteAccount(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <!-- 添加 编辑对话框 -->
    <el-dialog :close-on-click-modal="false" :title="dialogTitle" width="800px" :visible.sync="showDialog" append-to-body @close="resetForm">
      <el-form ref="form" label-position="left" auto :rules="rules" :model="form" label-width="80px">
        <el-form-item label-width="100px" prop="username" label="账号：">
          <el-input v-model="form.username" autocomplete="off" style="max-width: 200px" />
        </el-form-item>
        <el-form-item label-width="100px" prop="password" label="密码：">
          <el-input v-model="form.password" style="max-width: 200px; margin-right: 20px" autocomplete="new-password" show-password type="password" />
          <span style="color: #909399; font-size: 14px">
            <i class="el-icon-info" />
            <span>密码非必填，不填则代表不修改密码。</span>
          </span>
        </el-form-item>
        <el-form-item label-width="100px" prop="avator" label="头像：">
          <el-upload
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            class="avatar-uploader"
            action="/api/admin/file/upload"
            :show-file-list="false"
            :with-credentials="true"
          >
            <img v-if="form.avator" :src="form.avator" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item label-width="100px" prop="name" label="真实姓名：">
          <el-input v-model="form.name" autocomplete="off" style="max-width: 200px" />
        </el-form-item>
        <el-form-item label-width="100px" prop="contact" label="联系方式：">
          <el-input v-model="form.contact" style="max-width: 350px" autocomplete="off" />
        </el-form-item>
        <el-form-item label-width="100px" prop="companyId" label="所在公司：">
          <el-select
            v-model="form.companyId"
            filterable
            remote
            clearable
            placeholder="请输入关键词收索企业"
            :remote-method="getSearchCompanyByName"
            :loading="loading"
            @clear="form.companyId = null"
          >
            <el-option v-for="item in companyOpt" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <i v-show="searching" class="el-icon-loading" style="margin-left: 10px" />
        </el-form-item>
        <el-form-item label-width="100px" prop="zhiwei" label="职位：">
          <el-input v-model="form.zhiwei" style="max-width: 350px" autocomplete="off" />
        </el-form-item>
        <!-- <el-form-item label-width="100px" prop="email" label="接收简历邮箱：">
          <el-input v-model="form.email" style="max-width: 350px" autocomplete="off" />
        </el-form-item> -->
        <el-form-item label-width="100px" prop="status" label="账号状态：">
          <div style="line-height: 28px">
            <el-radio-group v-model="form.status">
              <el-radio :label="0">正常</el-radio>
              <!-- <el-radio :label="1">已封号</el-radio> -->
              <el-radio :label="1">已禁用</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <!-- <el-form-item label-width="100px" prop="auth" label="认证状态：">
          <div style="line-height: 28px">
            <el-radio-group v-model="form.auth">
              <el-radio :label="0">审核中</el-radio>
              <el-radio :label="1">认证通过</el-radio>
              <el-radio :label="2">认证拒绝</el-radio>
            </el-radio-group>
          </div>
        </el-form-item> -->
        <!-- <el-form-item v-if="form.auth == 2" label-width="100px" prop="reason" label="拒绝原因：">
          <el-input v-model="form.reason" autocomplete="off" clearable resize="none" type="textarea" />
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="previewImageDialog">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import pagination from '@/mixins/pagination'
import md5 from 'js-md5' // 引入Md5加密
import { deepClone } from '@/utils'
export default {
  mixins: [pagination],
  data() {
    return {
      authCount: {
        count: 0,
        loading: true
      },
      screenForm: {
        username: '',
        name: '',
        contact: ''
      },
      tableData: [],
      loading: true,
      showDialog: false,
      dialogTitle: '',
      form: {
        username: '',
        password: '',
        avator: '',
        name: '',
        contact: '',
        companyId: null,
        zhiwei: '',
        status: null
        // auth: null,
        // email: '',
        // reason: ''
      },
      rules: {
        username: [{ required: true, message: '请输入账号名', trigger: 'blur' }],
        avator: [{ required: true, message: '请上传头像', trigger: 'change' }],
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        contact: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[345789]\d{9}$/, message: '手机格式不整确', trigger: 'blur' }
        ],
        companyId: [{ required: true, message: '请选择企业', trigger: 'change' }],
        zhiwei: [{ required: true, message: '请输入职位', trigger: 'blur' }],
        status: [{ required: true, message: '请选择认证状态', trigger: 'change' }]
        // auth: [{ required: true, message: '请选择认证状态', trigger: 'change' }],
        // email: [
        //   { required: true, message: '请选择认证状态', trigger: 'blur' },
        //   { type: 'email', message: '邮箱格式不整确', trigger: 'blur' }
        // ],
      },
      companyOpt: [],
      searching: false,
      tableH: 0,
      ids: [] // 批量选中的账号组
    }
  },
  mounted() {
    this.getTableList() // 获取企业打卡管理列表
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    // 刷新
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.$refs.screenForm.resetFields()
      Promise.all([this.getTableList()])
        .then(() => {
          this.loading = false
          this.authCount.loading = false
        })
        .catch(() => {})
    },
    // 筛选
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Object.assign(this.page, this.screenForm)
      Promise.all([this.getTableList()])
        .then(() => {
          this.loading = false
          this.authCount.loading = false
        })
        .catch(() => {})
    },
    // 批量选中
    handleSelectionChange(e) {
      this.ids = e.map((item) => item.id)
      console.log(this.ids)
    },
    // 批量删除
    deleteGroup() {
      if (!this.ids.length) return this.$message.info('当前无选中项哦！')
      this.$api.clockIn
        .getDeleteInfo({ ids: this.ids.join(',') })
        .then((res) => {
          this.$message.success('操作成功')
          this.getTableList() // 获取企业打卡管理列表
        })
        .catch((e) => {
          this.$message.error(e)
        })
    },
    // 获取企业打卡管理列表
    getTableList() {
      this.loading = true
      return this.$api.clockIn
        .getPunchAccountList(this.page)
        .then((res) => {
          console.log(res)
          this.tableData = res.records
          this.total = res.total
          const ids = this.tableData
            .filter((item) => item.companyId)
            .map((item) => item.companyId)
            .join(',')
          this.getFindCompanyByIds({ ids }) // 所在公司
          this.getCompanyList({ ids }) // 账号管理ids接口
        })
        .catch((e) => {})
    },
    // 账号管理ids接口
    getCompanyList(data) {
      this.$api.clockIn
        .getPunchAccountIds(data)
        .then((res) => {
          let arr = Object.keys(res)
          if (arr.length == 0) return (this.loading = false)
          console.log(res)
          const companyList = res
          const map = new Map()
          companyList.forEach((item) => {
            map[item.id] = item
          })
          this.tableData.forEach((item) => {
            item.company = map[item.companyId]
          })
          this.tableData = JSON.parse(JSON.stringify(this.tableData))
          console.log(this.tableData)
          this.loading = false
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },
    // 所在公司
    getFindCompanyByIds(data) {
      this.$api.clockIn
        .getFindCompanyByIds(data)
        .then((res) => {
          console.log(res)
          let arr = Object.keys(res)
          if (arr.length == 0) return (this.loading = false)
          const companyList = res
          const map = new Map()
          companyList.forEach((item) => {
            map[item.id] = item
          })
          this.tableData.forEach((item) => {
            item.company = map[item.companyId]
          })
          this.tableData = JSON.parse(JSON.stringify(this.tableData))
          console.log(this.tableData)
          this.loading = false
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },
    // 打开添加/编辑账号弹窗
    openDialog(title, row) {
      this.dialogTitle = title
      this.showDialog = true
      row &&
        this.$nextTick(() => {
          // const { username, avator, contact, companyId, email, status, zhiwei, auth, id, name, reason } = row
          const { username, avator, name, contact, companyId, zhiwei, status, id } = row
          this.form.username = username
          this.form.avator = avator
          this.form.name = name
          this.form.contact = contact
          this.form.companyId = companyId
          this.form.zhiwei = zhiwei
          this.form.status = status
          this.form.id = id
          // this.form.email = email
          // this.form.auth = auth
          // this.form.reason = reason
          this.companyOpt = [{ value: row.companyId, label: row.company.companyName }]
        })
    },
    // 搜索公司
    getSearchCompanyByName(companyName) {
      this.searching = true
      this.companyOpt = []
      this.$api.clockIn
        .getSearchCompanyByName({ companyName })
        .then((res) => {
          this.companyOpt = res.map((item) => {
            return {
              value: item.id,
              label: item.companyName
            }
          })
          this.searching = false
        })
        .catch((e) => {})
    },
    // 提交
    handleSubmit() {
      if (!this.validateForm()) return
      const form = deepClone(this.form)
      if (form.password) {
        form.password = md5(form.password)
      } else {
        delete form.password
      }
      if (this.dialogTitle === '添加账号') {
        this.loading = true
        this.$api.clockIn
          .getSaveInfo(form)
          .then((res) => {
            this.showDialog = false
            this.getTableList() // 获取企业打卡管理列表
            this.$message.success('操作成功')
          })
          .catch((e) => {
            this.loading = false
            this.$message.error(e)
          })
      } else {
        console.log('edit')
        console.log(this.form)
        try {
          this.$api.clockIn
            .getUpdateInfo(form)
            .then((res) => {
              this.showDialog = false
              this.getTableList() // 获取企业打卡管理列表
              this.$message.success('操作成功')
            })
            .catch((e) => {
              this.loading = false
              this.$message.error(e)
            })
        } catch (error) {
          console.log(error)
        }
      }
    },
    // 关闭弹窗
    resetForm() {
      this.$refs.form.resetFields()
    },
    // 删除账号
    handleDeleteAccount(row) {
      this.$confirm('此操作将永久删除该账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$api.clockIn
            .getDeleteInfo({ ids: row.id })
            .then((res) => {
              this.$message({
                type: 'success',
                message: res
              })
              this.getTableList() // 获取企业打卡管理列表
            })
            .catch((e) => {
              this.$message({
                type: 'info',
                message: e
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 上传图片成功
    handleAvatarSuccess(res) {
      this.form.avator = res.data
      this.$refs.form.clearValidate('avator')
    },
    // 上传头像是否符合
    beforeAvatarUpload(file) {
      const isImg = /image/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImg) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isImg && isLt2M
    },
    // 表单验证
    validateForm() {
      let pass
      this.$refs.form.validate((res) => {
        pass = res
      })
      return pass
    }
    // 认证状态
    // verifyAccount(auth, id) {
    //   this.loading = true
    //   this.$api.company
    //     .reqUpdateAccountAuth({ auth, id })
    //     .then((res) => {
    //       this.loading = false
    //       this.$message.success('操作成功')
    //     })
    //     .catch((e) => {
    //       this.loading = false
    //       this.$message.error(e)
    //     })
    // },
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
